/* eslint-disable react/jsx-no-useless-fragment */
import clsx from 'clsx';
import './loading.scss';
import TableSkeleton from './TableSkeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type LoadingVariant = 'spinner' | 'full';

interface DataLoadingWrapperProps {
  loadingData: boolean;
  children: React.ReactNode;
  description?: string;
  descriptionClassName?: string;
  variant?: LoadingVariant | 'tableSkeleton';
  cols?: number;
  rows?: number;
  customLoader?: JSX.Element;
  className?: string;
}

const LOADING_VARIANT: Record<LoadingVariant, JSX.Element> = {
  spinner: (
    <div className="spinner-container text-center p-2">
      <div className="spinner" />
    </div>
  ),
  full: <div className="spinner !m-0 !w-[40px] !h-[40px]" />,
};

const DataLoadingWrapper = ({
  children,
  loadingData,
  description,
  descriptionClassName,
  variant = 'full',
  cols = 8,
  rows = 5,
  customLoader,
  className,
}: DataLoadingWrapperProps) => {
  if (loadingData) {
    if (variant === 'tableSkeleton') {
      return <TableSkeleton cols={cols} rows={rows} />;
    }
    return (
      <div className={clsx('w-full', className)}>
        {!customLoader ? LOADING_VARIANT[variant] : customLoader}
        {description && (
          <p className={clsx('text-center', descriptionClassName)}>
            {description}
          </p>
        )}
      </div>
    );
  }

  return <>{children}</>;
};

export default DataLoadingWrapper;
